import React from 'react'
import { View, Animated, Dimensions } from 'react-native'
import PropTypes from 'prop-types'

const { width } = Dimensions.get('window')

function WheelSelector(props) {

  const {
    entries,
    style,
    setSelected,
    scrollY,
    carouselRef,
    selected,
    ...rest
  } = props

  const keyExtractor = (_, index) => 'item-' + index

  let itemWidth = width / 5
  let listPadding = (width + 32) / 3
  if (entries.length <= 4) {
    itemWidth = width / 3
    listPadding = (width - 32) / 3
  }

  return (
    <View onStartShouldSetResponder={() => true}>
      <Animated.FlatList
        keyExtractor={keyExtractor}
        ref={carouselRef}
        onScroll={Animated.event(
          [{
            nativeEvent: {
              contentOffset: {
                x: scrollY,
              },
            },
          }],
          {
            useNativeDriver: true,
          }
        )}
        horizontal
        initialScrollIndex={0}
        onStartShouldSetResponder={() => true}
        showsHorizontalScrollIndicator={false}
        data={entries}
        decelerationRate={0.9}
        onMomentumScrollEnd={(event) => {
          // const itemWidth = (itemWidthh) / 3
          const index = Math.round(event.nativeEvent.contentOffset.x / itemWidth)
          setSelected(index)
        }}
        snapToAlignment="center"
        pagingEnabled
        snapToOffsets={[...Array(entries.length)].map((_, i) => (i * ((itemWidth))))}
        contentContainerStyle={{ paddingHorizontal: listPadding }}
        {...rest}
      />
    </View>
  )
}


WheelSelector.propTypes = {
  entries: PropTypes.array,
  setSelected: PropTypes.func,
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  scrollY: PropTypes.number,
  carouselRef: PropTypes.object,
}

export default WheelSelector
